import { formatDate } from '@utils/formatter';
import PaymentBubble from '../PaymentBubble';
import { PaymentBubbleCommonProps } from '../types';

export default function ShippingStartBubble({
  chatMessage,
  history
}: PaymentBubbleCommonProps) {
  const expectedConfirmPurchaseDate = formatDate(
    chatMessage?.rfq?.expectedConfirmPurchaseDate ?? 0,
    'YYYY.MM.DD'
  );

  const onClickButton = () => {
    if (!history) return;
    const { pathname } = history.location;
    history.push(`${pathname}?menu=purchaseorder`);
  };

  return (
    <PaymentBubble>
      <PaymentBubble.Title>배송이 시작되었습니다.</PaymentBubble.Title>
      <PaymentBubble.Stepper activeStep={3} />
      <PaymentBubble.Content>
        파트너가 제조를 마치고 배송을 시작했습니다. 검품 후 이상이 없다면
        구매확정해주세요.
      </PaymentBubble.Content>
      <PaymentBubble.Content>
        자동 구매확정일 : {expectedConfirmPurchaseDate}
      </PaymentBubble.Content>
      <PaymentBubble.Button buttonAction={onClickButton}>
        제조현황 확인
      </PaymentBubble.Button>
    </PaymentBubble>
  );
}
